import React from 'react';

import { Container } from '../../../../symphony';

import {
	REPLIES_COUNT_BY_PAGE,
	SlDiscussContext,
} from '../../global-constants';
import { ActionType, RequestType } from '../../global-interface';
import { SlDataService } from '../../services/sl-data.service';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { PaginationItem } from '../../../../shared/public/SlPagination/types';
import { SlPagination } from '../../../../shared/public/SlPagination/SlPagination';

export function RepliesPaginationContainer() {
	const { actions$ } = Container.take(SlDiscussContext, SlActions);
	const { question$: question } = useContainerData(
		SlDiscussContext,
		SlDataService,
		['question$'],
	);

	if (!question) return null;

	const handleItemClick = (item: PaginationItem) => {
		actions$.next({
			type: ActionType.OnPaginationClick,
			requestType: RequestType.Parallel,
			data: item,
		});
	};

	return (
		<SlPagination
			totalCount={question.answers}
			rowsPerPage={REPLIES_COUNT_BY_PAGE}
			onItemClick={handleItemClick}
		/>
	);
}
